import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";

const { gradients } = colors;

function configs(labels, datasets) {

  return {
    data: {
      labels,
      datasets: [
        {
          label: datasets.label,
          backgroundColor: datasets.backgroundColors.map(color => { return rgba(gradients[color].state, 0.8) }),
          borderColor: datasets.backgroundColors.map(color => { return gradients[color].state }),
          fill: true,
          data: datasets.data,
          borderRadius: 6,
          borderSkipped: false,
          barPercentage: 0.9,
          categoryPercentage: 0.9,
        },
      ],
    },
    options: {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false, // <-- CHANGED: Must be false to prevent vertical looping
      plugins: {
        legend: false
      },
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        y: {
          position: 'right',
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
        x: {
          beginAtZero: true,
          grace: 25,
          reverse: true,
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
      },
    }
  };
}

export default configs;